import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  margin-top: ${em(7)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(23)};
  }

  ${p => p.theme.mq.upLg} {
    margin-top: ${em(30)};
  }
`
